/**
 * Shared contact-blob language for poles and props: a flattened oval at the
 * plant / waterline. Not a smeared sprite copy.
 */

export const CONTACT_BLOB_FLATTEN = 0.55;
export const CONTACT_BLOB_MIX = 0.18;
/** Prop oval width as a fraction of the sprite box. */
export const PROP_CONTACT_WIDTH_FACTOR = 0.38;

export function contactBlobAxes(width: number): { width: number; height: number } {
  return { width, height: width * CONTACT_BLOB_FLATTEN };
}
